const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ1: {
				name: ['出勤', 'Attendance', '出勤'],
				children: {
					ZZ_PETSMALL_AM10001: {
						name: ['自動產生加班資料參數設定', 'Auto Generate Overtime Parameters', '自动产生加班资料参数设定'],
						url: '/zz_petsmall_am10001',
						hint: [],
					},
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};